const hydrateProductVariantPickerComingSoon = () => {
    const variantSelectors = Array.from(document.querySelectorAll(`input[type="radio"]`))

    const handleInputChange = (e) => {
        const input = e.target;
        const tagsInput = document.querySelector(`input[name="contact[tags]"][data-option="${input.dataset.option}"]`)

        tagsInput.value = input.value
    }

    for(const input of variantSelectors) {
        input.addEventListener("change", handleInputChange);
    }
}

hydrateProductVariantPickerComingSoon();